import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  Alert,
} from 'reactstrap';
import { facturasService } from '../../services/facturasService';

function GenerarFacturaModal({ isOpen, toggle, venta, onSuccess }) {
  const [serie, setSerie] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!venta) {
      setError('No se ha seleccionado una venta');
      return;
    }

    try {
      setLoading(true);

      const facturaData = {
        VentaID: venta.VentaID || venta.ventaID,
        Serie: serie.trim() || null,
      };

      const response = await facturasService.generar(facturaData);

      if (response.success) {
        onSuccess();
      } else {
        setError(response.Message || response.message || 'Error al generar la factura');
      }
    } catch (err) {
      setError(err.message || 'Error al conectar con el servidor');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setSerie('');
    setError('');
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="md" className="modal-black">
      <form onSubmit={handleSubmit}>
        <ModalHeader toggle={handleClose}>Generar Factura</ModalHeader>
        <ModalBody>
          {error && (
            <Alert color="danger" className="mb-3">
              {error}
            </Alert>
          )}

          {venta && (
            <div className="mb-3">
              <p>
                <strong>Venta:</strong> {venta.Folio || venta.folio || `#${venta.VentaID || venta.ventaID}`}
              </p>
              <p>
                <strong>Cliente:</strong> {venta.ClienteNombre || venta.clienteNombre || 'Cliente General'}
              </p>
              <p>
                <strong>Total:</strong> {new Intl.NumberFormat('es-MX', {
                  style: 'currency',
                  currency: 'MXN',
                }).format(venta.Total !== undefined ? venta.Total : (venta.total !== undefined ? venta.total : 0))}
              </p>
            </div>
          )}

          <Label>Serie (Opcional)</Label>
          <Input
            type="text"
            value={serie}
            onChange={(e) => setSerie(e.target.value)}
            placeholder="Ej: A"
            maxLength={10}
          />
          <small className="text-muted">
            Si no se especifica, se usará la serie por defecto del sistema.
          </small>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose} disabled={loading}>
            Cancelar
          </Button>
          <Button color="primary" type="submit" disabled={loading || !venta}>
            {loading ? 'Generando...' : 'Generar Factura'}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
}

export default GenerarFacturaModal;

